import { Routes, Route } from 'react-router-dom'
import { ScrollToTop } from './components/ScrollToTop'
import { Error, SharedLayout, Login } from './pages/index'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { clientRoutes } from './routes/clientRoutes'
import { adminRoutes } from './routes/adminRoutes'
import { SpinnerCondition } from './SpinnerCondition'
import useAuth from './hooks/useAuth'
import { ConfirmModal } from 'components/ConfirmModal/ConfirmModal'
import { useDispatch, useSelector } from 'react-redux'
import { setConfirmModal } from 'features/global/globalSlice'
import { AppDispatch, RootState } from 'store'
import { IRoute } from 'types/global.interface'
import { ThemeProvider } from 'styled-components'
import { darkTheme, lightTheme } from 'styling/GlobalStyles'
import OverlayProvider from 'OverlayContext'
import { createPortal } from 'react-dom'

const Home = () => {
  const { isAdmin } = useAuth()
  const { confirmModal } = useSelector((store: any) => store.globals)
  const dispatch = useDispatch<AppDispatch>()

  const handleCancel = () => {
    dispatch(setConfirmModal({ isOpen: false }))
    confirmModal.onCancel && confirmModal.onCancel()
  }

  const renderRoutes = (routes) => {
    return routes.map((route: IRoute, index: number) => {
      return <Route path={route.path} element={<OverlayProvider><route.Component /></OverlayProvider>} key={index} />
    })
  }

  return (
    <>
      <SpinnerCondition />
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<SharedLayout />}>
          {renderRoutes(isAdmin ? adminRoutes : clientRoutes)}
        </Route>
        <Route path='*' element={<Error />} />
      </Routes >
      {
        createPortal(<ToastContainer
          closeButton={false}
          pauseOnHover={false}
          closeOnClick={true}
          autoClose={2500}
          position='top-center'
          style={{ zIndex: 99999999 }}
        />, document.body)
      }
      {
        confirmModal.isOpen && (
          <ConfirmModal
            word={confirmModal.word}
            onSave={confirmModal.onSave}
            onCancel={handleCancel}
            setParams={confirmModal.setParams}
            sentence={confirmModal.sentence}
            cancelText={confirmModal.cancelText}
            confirmText={confirmModal.confirmText}

          />
        )
      }
    </>
  )
}

const App = () => {
  const auth = useAuth()
  const { darkMode } = useSelector((store: RootState) => store.globals)
  return <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>{auth.user ? <Home /> : <Login />}
  </ThemeProvider>
}

export default App
